import React from 'react'
import { Provider } from 'react-redux'
import store from 'app/store'
import { ThemeProvider } from '@mui/material/styles'
import BoundaryError from 'common/components/BoundaryError'
import theme from 'app/theme'
import WaitContainer from 'common/components/WaitContainer'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import LoginApp from 'login/LoginApp'
import DashboardApp from 'dashboard/DashboardApp'
import InstancesApp from 'supervision/instances/InstancesApp'
import TimeErrorsApp from 'supervision/timeErrors/TimeErrorsApp'
import UsersApp from 'admin/users/UsersApp'
import UserApp from 'admin/user/UserApp'
import AquaparcApp from 'common/AquaparcApp'
import InstanceApp from 'supervision/instance/InstanceApp'
import InstanceDasboardApp from 'supervision/instance/components/InstanceDashboardApp'
import InstanceDescriptionApp from 'supervision/instance/components/InstanceDescriptionApp'
import AdminFeaturesApp from 'gdl/adminFeatures/AdminFeaturesApp'
import CustomersListApp from 'gdl/customers/CustomersListApp'
import CustomersApp from 'gdl/customers/CustomersApp'
import CustomerApp from 'gdl/customer/CustomerApp'
import CustomerDashboardApp from 'gdl/customer/components/CustomerDashboardApp'
import CommercialFeatureApp from 'gdl/commercial/commercialFeature/components/CommercialFeatureApp'
import CommercialApp from 'gdl/commercial/CommercialApp'
import CommercialProductApp from 'gdl/commercial/product/components/CommercialProductApp'
import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router'
import { Flip, ToastContainer } from 'react-toastify'
import AuthenticatedComponent from 'common/components/AuthenticatedComponent'
import InstanceLicenseApp from 'supervision/instance/components/InstanceLicenseApp'
import ServicesApp from 'supervision/services/ServicesApp'
import InstancesMenuApp from 'supervision/InstancesMenuApp'
import DashboardProdApp from 'supervision/dashboardProd/DashboardProdApp'
import IssueApp from 'support/issue/IssueApp'
import StatisticsSupportApp from 'support/statistics/StatisticsSupportApp'
import DashboardSupportApp from 'support/dashboard/DashboardSupportApp'
import DevsApp from 'dev/DevsApp'
import RecetteApp from 'recette/RecetteApp'
import CustomerNotesApp from 'gdl/customer/components/CustomerNotesApp'
import ContactsListApp from 'gdl/customers/ContactsListApp'
import AllLotsApp from 'gdl/customers/AllLotsApp'
import RoadmapApp from 'roadmap/RoadmapApp'
import RoadmapMenuApp from 'roadmap/RoadmapMenuApp'
import PrioritesApp from 'roadmap/PrioritesApp'
import MyTicketsApp from 'dev/MyTicketsApp'
import VersionsApp from 'versions/VersionsApp'
import CustomerTicketsApp from 'gdl/customer/components/CustomerTicketsApp'
import CustomerLotsApp from 'gdl/customer/components/CustomerLotsApp'
import InstanceServiceApp from 'supervision/instance/components/InstanceServiceApp'
import RecettesApp from 'recette/RecettesApp'
import AgendaApp from 'common/AgendaApp'
import StatisticsSupervisionApp from 'supervision/statistics/StatisticsSupervisionApp'

const NoMatch = () => (
    <div style={{ margin: 10 }}>
        <h2>Rien à voir ici !</h2>
        <p>
            <Link to='/'>Retourner à la page d'accueil</Link>
        </p>
    </div>
)

const App = () => {
    if (window.location.href.includes('access_token')) {
        const matches = [...window.location.href.matchAll('access_token=([a-z0-9A-Z\\.]*)')]
        if (matches.length && matches[0].length && matches[0][1]) {
            window.opener.postMessage({
                type: 'loginDiscordSuccess',
                token: matches[0][1],
            }, window.location.origin)

            window.close()
        }
        return null
    }
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <BrowserRouter basename='/'>
                    <Provider store={store}>
                        <BoundaryError>
                            <ToastContainer
                                position='bottom-left'
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable={false}
                                pauseOnHover
                                theme='colored'
                                transition={Flip}
                            />
                            <WaitContainer />
                            <Routes>
                                <Route path='/login' element={<LoginApp />} />
                                <Route path='/' element={<AuthenticatedComponent Component={AquaparcApp} />}>
                                    <Route index element={<Navigate replace path='' to='dashboard/map' />} />
                                    <Route path='dashboard/:tab' element={<DashboardApp />} />
                                    <Route path='agenda' element={<AgendaApp />} />

                                    {/* SUPERVISION */}
                                    <Route path='dashboardProd' element={<DashboardProdApp />} />
                                    <Route element={<InstancesMenuApp />}>
                                        <Route path='service' element={<ServicesApp />} />
                                        <Route path='instance' element={<InstancesApp />} />
                                    </Route>
                                    <Route path='instance'>
                                        <Route path=':id' element={<InstanceApp />}>
                                            <Route index element={<Navigate replace path='' to='dashboard' />} />
                                            <Route path='dashboard' element={<InstanceDasboardApp />} />
                                            <Route path='description' element={<InstanceDescriptionApp />} />
                                            <Route path='license' element={<InstanceLicenseApp />} />
                                            <Route path='service/:idService' element={<InstanceServiceApp />} />
                                        </Route>
                                    </Route>
                                    <Route path='timeError' element={<TimeErrorsApp />} />
                                    <Route path='statisticsSupervision' element={<StatisticsSupervisionApp />} />

                                    {/* SUPPORT */}
                                    <Route path='support'>
                                        <Route path='dashboard' element={<DashboardSupportApp />} />
                                    </Route>
                                    <Route path='issue' element={<IssueApp />} />
                                    <Route path='statistics' element={<StatisticsSupportApp />} />

                                    {/* Développements */}
                                    <Route path='tickets/:login' element={<MyTicketsApp />} />
                                    <Route path='devs' element={<DevsApp />} />
                                    <Route path='roadmap' element={<RoadmapMenuApp />}>
                                        <Route index element={<RoadmapApp />} />
                                        <Route path='priorites' element={<PrioritesApp />} />
                                    </Route>

                                    {/* Recette */}
                                    <Route path='recette'>
                                        <Route path='' element={<RecettesApp />}>
                                            <Route index element={<Navigate replace path='' to='dashboard' />} />
                                            <Route path='dashboard' element={<RecetteApp />} />
                                            <Route path='iaeau' element={<RecetteApp iaeau />} />
                                            <Route path='versions' element={<VersionsApp />} />
                                        </Route>
                                    </Route>

                                    {/* GDL */}
                                    <Route path='customer'>
                                        <Route path='' element={<CustomersApp />}>
                                            <Route index element={<Navigate replace path='' to='dashboard' />} />
                                            <Route path='dashboard' element={<CustomersListApp />} />
                                            <Route path='contacts' element={<ContactsListApp />} />
                                            <Route path='lots' element={<AllLotsApp key='lots' />} />
                                            <Route path='ideas' element={<AllLotsApp key='ideas' ideas />} />
                                        </Route>
                                        <Route index element={<CustomersApp />} />
                                        <Route path=':id' element={<CustomerApp />}>
                                            <Route index element={<Navigate replace path='' to='dashboard' />} />
                                            <Route path='dashboard' element={<CustomerDashboardApp />} />
                                            <Route path='notes' element={<CustomerNotesApp />} />
                                            <Route path='tickets' element={<CustomerTicketsApp />} />
                                            <Route path='lots' element={<CustomerLotsApp key='lots' />} />
                                            <Route path='ideas' element={<CustomerLotsApp key='ideas' ideas />} />
                                        </Route>
                                    </Route>
                                    <Route path='settingLicense' element={<AdminFeaturesApp />} />
                                    <Route path='commercial' element={<CommercialApp />}>
                                        <Route index element={<Navigate replace path='' to='feature' />} />
                                        <Route path='feature' element={<CommercialFeatureApp />} />
                                        <Route path='product' element={<CommercialProductApp />} />
                                    </Route>

                                    {/* ADMIN */}
                                    <Route path='user' element={<UsersApp />} />
                                    <Route path='user/:login' element={<UserApp />} />

                                    <Route path='*' element={<NoMatch />} />
                                </Route>
                            </Routes>
                        </BoundaryError>
                    </Provider>
                </BrowserRouter>
            </LocalizationProvider>
        </ThemeProvider>
    )
}

export default App